import {
    Component, Input, Output, EventEmitter, OnInit, OnChanges,
    SimpleChanges, ChangeDetectorRef
} from '@angular/core';
import Swal from 'sweetalert2';

export interface MetaComision {
    plazoValor: number | null;
    categoriaAsesorId: number | null;
    empleado: string | null;
    comision: number;
}

@Component({
    selector: 'app-modal-meta-form-v2',
    templateUrl: './modal-meta-form-v2.component.html',
    styleUrls: ['./modal-meta-form-v2.component.css']
})
export class ModalMetaFormV2Component implements OnInit, OnChanges {

    // ── Inputs del padre ──────────────────────────────────────────
    @Input() metaForm: any = {
        metaPromocionId: null,
        fechaInicio: '',
        fechaFin: '',
        fechaCorte: '',
        objetivo: null,
        comisionMeta: null,
    };
    @Input() isEditMode = false;
    @Input() promoShowConfig: any = {};
    @Input() promoPlazosCatalog: any[] = [];
    @Input() promoCategoriesView: any[] = [];
    @Input() promoAsesorView: any[] = [];
    @Input() plazosCatalog: any[] = [];
    @Input() categoriesViewCatalog: any[] = [];
    @Input() employeeJobCatalog: any[] = [];
    @Input() businessProductCatalog: any[] = [];
    @Input() genderCatalog: any[] = [];
    @Input() civilStatusCatalog: any[] = [];
    @Input() typeEmployeeCatalog: any[] = [];
    @Input() typeSaleCatalog: any[] = [];
    @Input() nuevoClienteCatalog: any[] = [];
    @Input() regionCatalog: any[] = [];
    @Input() stateViewCatalog: any[] = [];
    @Input() sucursalViewCatalog: any[] = [];
    @Input() productViewCatalog: any[] = [];
    @Input() dependenciesViewCatalog: any[] = [];
    @Input() clavePromocionCatalog: any[] = [];
    @Input() metaComisionesExistentes: any[] = [];
    @Input() metaFiltroExistente: any = null;
    @Input() promotionName: string = '';

    // ── Outputs al padre ──────────────────────────────────────────
    @Output() guardar = new EventEmitter<any>();
    @Output() cancelar = new EventEmitter<void>();

    // ── Schema de la meta ─────────────────────────────────────────
    public metaSchema: any = null;
    public metaSelectedFieldIds: number[] = [];
    public checkErrorMetaSchema = false;
    public showMetaFieldsModal = false;

    // ── showConfig de la meta ─────────────────────────────────────
    public metaShowConfig: any = {
        fieldAsesorType: false, fieldBusinessLine: false, fieldTasaAnual: false,
        fieldGender: false, fieldAge: false, fieldCivilStatus: false,
        fieldEmployeeType: false, fieldSaleType: false, fieldNuevoCliente: false,
        fieldCapitalAmount: false, fieldRegion: false, fieldState: false,
        fieldSucursal: false, fieldProduct: false, fieldDependency: false,
        fieldClavePromocion: false, fieldPaymentTerm: false,
        fieldCategoryAsesor: false, fieldAsesor: false,
    };

    // ── Configuración interna de filtros ──────────────────────────
    public metaConfiguration: any = {
        typeAsesor: [], businessLine: [], gender: [], civilStatus: [],
        typeEmployee: [], typeSale: [], region: [], estado: [],
        sucursal: [], dependencia: [], producto: [], clavePromocion: [],
        nuevoCliente: [], paymentTerms: [], categoryAsesor: [],
        minAge: 0, maxAge: 100,
        minCapitalAmount: 0, maxCapitalAmount: 10000000, tasaAnual: 0,
    };

    // ── Catálogos locales ─────────────────────────────────────────
    public metaPlazosCatalog: any[] = [];
    public metaPlazosCatalogView: any[] = [];
    public metaCategoriesView: any[] = [];
    public metaPaymentCategoryCatalog: any[] = [];
    public metaAsesorViewCatalog: any[] = [];
    public metaStateViewCatalog: any[] = [];
    public metaSucursalViewCatalog: any[] = [];
    public metaProductViewCatalog: any[] = [];
    public metaDependenciesViewCatalog: any[] = [];

    // ── Seleccionados para dropdowns ──────────────────────────────
    public metaSelectedEmployeeJob: any[] = [];
    public metaSelectedBusinessProduct: any[] = [];
    public metaSelectedGender: any[] = [];
    public metaSelectedCivilStatus: any[] = [];
    public metaSelectedTypeEmployee: any[] = [];
    public metaSelectedTypeSale: any[] = [];
    public metaSelectedNuevoCliente: any[] = [];


    // ── Vista de comisiones ───────────────────────────────────────
    public metaComisionesView: any[] = [];

    // ── Secciones colapsables ─────────────────────────────────────
    public sectionOpen = {
        comisionesMeta: true,
        asesorPlazosMeta: true,
        asesorMeta: true,
        clienteMeta: true,
        capitalMeta: true,
        geografiaMeta: true,
    };

    // ── Errores de formulario ─────────────────────────────────────
    public checkErrorObjetivo = false;
    public checkErrorFechaInicio = false;
    public checkErrorFechaFin = false;
    public checkErrorFechaCorte = false;
    public checkErrorComisionMeta = false;
    public checkErrorTablaPlazos = false;
    public checkErrorTablaCategorias = false;
    public checkErrorTablaMetaPlazos = false;
    public checkErrorTablaMetaPlazosxCats = false;
    public checkErrorTablaMetaCategorias = false;
    public checkErrorRegion = false;
    public checkErrorEstado = false;
    public checkErrorSucursal = false;
    public checkErrorProducto = false;
    public checkErrorDependencia = false;

    public checkErrorNombrePromocion: boolean = false;

    // ← Flag para forzar re-render de la tabla de plazos
    public listPlazoActive = true;

    constructor(private cdr: ChangeDetectorRef) { }

    // ─────────────────────────────────────────────────────────────
    // Lifecycle
    // ─────────────────────────────────────────────────────────────

    ngOnInit(): void {
        console.log("Modo de vizualizacion: {}", this.isEditMode);
        this.buildMetaComisionesView();

        console.log("categoriesViewCatalog", this.categoriesViewCatalog);
        console.log("metaCategoriesView", this.metaCategoriesView);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const inputsRelevantes = [
            'promoShowConfig', 'promoPlazosCatalog', 'promoCategoriesView',
            'promoAsesorView', 'metaComisionesExistentes', 'metaFiltroExistente',
            'categoriesViewCatalog'
        ];

        const hubocambio = inputsRelevantes.some(key => !!changes[key]);
        if (!hubocambio) return;

        // 1. Inicializar vistas locales PRIMERO
        if (changes['promoPlazosCatalog']) {
            const plazosCatalogToUse = this.promoPlazosCatalog && this.promoPlazosCatalog.length
                ? this.promoPlazosCatalog
                : this.plazosCatalog;
            this.metaPlazosCatalog = plazosCatalogToUse.map(p => ({
                ...p, selected: true, comission: 0
            }));
            this.metaPlazosCatalogView = plazosCatalogToUse.map(p => ({
                ...p, selected: true, comission: 0
            }));
            if (this.metaFiltroExistente) {
                this.preCargarFiltroExistente(this.metaFiltroExistente);
            }

        }

        if (changes['categoriesViewCatalog'] && this.categoriesViewCatalog.length) {
            this.metaCategoriesView = this.categoriesViewCatalog.map(c => ({
                ...c, selected: false
            }));
        }

        // 2. Reconstruir tabla Plazos x Categorías si aplica
        if (this.categoriesViewCatalog.length &&
            this.metaShowConfig.fieldPaymentTerm &&
            this.metaShowConfig.fieldCategoryAsesor) {
            this.reconstruirMetaPaymentCategory();
        }

        // 3. Cargar filtro DESPUÉS de inicializar vistas
        if (changes['metaFiltroExistente'] && this.metaFiltroExistente) {
            this.preCargarFiltroExistente(this.metaFiltroExistente);
        } else if (this.metaFiltroExistente && changes['categoriesViewCatalog']) {
            this.preCargarFiltroExistente(this.metaFiltroExistente);
        } else if (this.metaFiltroExistente && changes['promoPlazosCatalog']) {
            this.preCargarFiltroExistente(this.metaFiltroExistente);
        }


        if (changes['stateViewCatalog']) {
            // ← Sin región seleccionada: mostrar todos los estados
            if (!this.metaShowConfig.fieldRegion || !this.metaConfiguration.region.length) {
                this.metaStateViewCatalog = [...this.stateViewCatalog];
            }
        }
        if (changes['sucursalViewCatalog']) {
            // ← Sin estado seleccionado: mostrar todas las sucursales
            if (!this.metaShowConfig.fieldState || !this.metaConfiguration.estado.length) {
                this.metaSucursalViewCatalog = [...this.sucursalViewCatalog];
            }
        }
        if (changes['productViewCatalog']) {
            // ← Sin línea de negocio seleccionada: mostrar todos los productos
            if (!this.metaShowConfig.fieldBusinessLine || !this.metaConfiguration.businessLine.length) {
                this.metaProductViewCatalog = [...this.productViewCatalog];
            }
        }
        if (changes['dependenciesViewCatalog']) {
            // ← Sin producto seleccionado: mostrar todas las dependencias
            if (!this.metaShowConfig.fieldProduct || !this.metaConfiguration.producto.length) {
                this.metaDependenciesViewCatalog = this.getDependenciasSinDuplicados(this.dependenciesViewCatalog);
            }
        }

        // 4. Construir vista de comisiones
        this.buildMetaComisionesView();

    }

    // ── Modal de campos ───────────────────────────────────────────

    openMetaFieldsModal(): void {
        this.metaSelectedFieldIds = [];
        this.showMetaFieldsModal = true;
    }

    editMetaFieldsModal(): void {
        this.metaSelectedFieldIds = (this.metaSchema && this.metaSchema.campos)
            ? this.metaSchema.campos.map((c: any) => c.campoId)
            : [];
        this.showMetaFieldsModal = true;
    }

    onMetaFieldsSelected(campos: any[]): void {

        if (campos && campos.length) this.checkErrorMetaSchema = false;
        const camposAnteriores = (this.metaSchema && this.metaSchema.campos)
            ? this.metaSchema.campos.map((c: any) => c.campoId)
            : [];
        const camposNuevos = campos.map((c: any) => c.campoId);
        const camposEliminados = camposAnteriores.filter(id => !camposNuevos.includes(id));

        this.metaSchema = { campos, fields: campos };
        this.metaSelectedFieldIds = camposNuevos;

        this.metaShowConfig = {
            fieldAsesorType: false, fieldBusinessLine: false, fieldTasaAnual: false,
            fieldGender: false, fieldAge: false, fieldCivilStatus: false,
            fieldEmployeeType: false, fieldSaleType: false, fieldNuevoCliente: false,
            fieldCapitalAmount: false, fieldRegion: false, fieldState: false,
            fieldSucursal: false, fieldProduct: false, fieldDependency: false,
            fieldClavePromocion: false, fieldPaymentTerm: false,
            fieldCategoryAsesor: false, fieldAsesor: false,
        };

        camposNuevos.forEach(id => this.activarCampoMeta(id));
        camposEliminados.forEach(id => this.limpiarCampoMeta(id));

        if (this.metaShowConfig.fieldPaymentTerm && this.metaShowConfig.fieldCategoryAsesor) {
            this.reconstruirMetaPaymentCategory();
        }

        if (this.metaShowConfig.fieldRegion) {
            const estados = [];
            this.metaConfiguration.region.forEach((region: any) => {
                estados.push(...this.stateViewCatalog.filter(s => s._regionId === region._id));
            });
            this.metaStateViewCatalog = estados;

            if (this.metaShowConfig.fieldState) {
                this.metaConfiguration.estado = []; // ← usuario elige
            } else {
                this.metaConfiguration.estado = [...this.metaStateViewCatalog]; // ← simular todos
            }
            this.onMetaEstadoChange();
        } else {
            this.metaStateViewCatalog = [...this.stateViewCatalog];
            this.metaSucursalViewCatalog = [...this.sucursalViewCatalog];
        }

        if (this.metaShowConfig.fieldBusinessLine) {
            const products = [];
            this.metaConfiguration.businessLine.forEach((line: any) => {
                products.push(...this.productViewCatalog.filter(
                    p => p._bussinesLineId === line.id && p.core === line.core
                ));
            });
            const ids = products.map(p => p._id_int).filter((v, i, a) => a.indexOf(v) === i);
            this.metaProductViewCatalog = ids.map(id => products.find(p => p._id_int === id));
            this.metaConfiguration.producto = []; // ← limpiar para que el usuario seleccione
            this.onMetaProductChange();
        } else {
            this.metaProductViewCatalog = [...this.productViewCatalog];
            this.metaDependenciesViewCatalog = this.getDependenciasSinDuplicados(this.dependenciesViewCatalog);
        }

        if (this.metaShowConfig.fieldAsesorType) {
            this.metaCategoriesView = [];
        } else {
            // Sin filtro de tipo asesor: todas las categorías pero sin duplicados
            this.metaCategoriesView = this.getCategoriasSinDuplicados(this.categoriesViewCatalog)
                .map(c => ({ ...c, selected: false }));
            // No llamar onMetaTypeAsesorChange con typeSaleCatalog porque eso re-filtraría por fatherId
            if (this.metaShowConfig.fieldPaymentTerm && this.metaShowConfig.fieldCategoryAsesor) {
                this.reconstruirMetaPaymentCategory();
            }
        }

        this.showMetaFieldsModal = false;
        this.buildMetaComisionesView();
    }

    onMetaFieldsModalClosed(): void {
        this.showMetaFieldsModal = false;
    }

    // ── Activar / limpiar campos ──────────────────────────────────

    private activarCampoMeta(campoId: number): void {
        const mapa: { [key: number]: () => void } = {
            1: () => { this.metaShowConfig.fieldRegion = true; },
            2: () => { this.metaShowConfig.fieldState = true; },
            3: () => { this.metaShowConfig.fieldSucursal = true; },
            4: () => { this.metaShowConfig.fieldAsesorType = true; },
            5: () => { this.metaShowConfig.fieldCategoryAsesor = true; },
            6: () => { this.metaShowConfig.fieldDependency = true; },
            7: () => { this.metaShowConfig.fieldProduct = true; },
            8: () => { this.metaShowConfig.fieldPaymentTerm = true; },
            12: () => { this.metaShowConfig.fieldSaleType = true; },
            13: () => { this.metaShowConfig.fieldGender = true; },
            14: () => { this.metaShowConfig.fieldAge = true; },
            15: () => { this.metaShowConfig.fieldCivilStatus = true; },
            16: () => { this.metaShowConfig.fieldEmployeeType = true; },
            17: () => { this.metaShowConfig.fieldBusinessLine = true; },
            18: () => { this.metaShowConfig.fieldCapitalAmount = true; },
            19: () => { this.metaShowConfig.fieldTasaAnual = true; },
            20: () => { this.metaShowConfig.fieldClavePromocion = true; },
            21: () => { this.metaShowConfig.fieldNuevoCliente = true; },
            22: () => { this.metaShowConfig.fieldAsesor = true; },
        };
        const fn = mapa[campoId];
        if (fn) fn();
    }

    private limpiarCampoMeta(campoId: number): void {
        const mapa: { [key: number]: () => void } = {
            1: () => { this.metaConfiguration.region = []; },
            2: () => { this.metaConfiguration.estado = []; },
            3: () => { this.metaConfiguration.sucursal = []; },
            4: () => { this.metaConfiguration.typeAsesor = []; this.metaSelectedEmployeeJob = []; },
            5: () => { this.metaConfiguration.categoryAsesor = []; },
            6: () => { this.metaConfiguration.dependencia = []; },
            7: () => { this.metaConfiguration.producto = []; },
            8: () => {
                this.metaConfiguration.paymentTerms = [];
                this.metaPlazosCatalog = this.metaPlazosCatalog.map(p => ({ ...p, selected: true, comision: 0 }));
                this.metaPlazosCatalogView = this.metaPlazosCatalogView.map(p => ({ ...p, selected: true, comision: 0 }));
                this.metaPaymentCategoryCatalog = [];
            },
            12: () => { this.metaConfiguration.typeSale = []; this.metaSelectedTypeSale = []; },
            13: () => { this.metaConfiguration.gender = []; this.metaSelectedGender = []; },
            14: () => { this.metaConfiguration.minAge = 0; this.metaConfiguration.maxAge = 100; },
            15: () => { this.metaConfiguration.civilStatus = []; this.metaSelectedCivilStatus = []; },
            16: () => { this.metaConfiguration.typeEmployee = []; this.metaSelectedTypeEmployee = []; },
            17: () => { this.metaConfiguration.businessLine = []; this.metaSelectedBusinessProduct = []; },
            18: () => { this.metaConfiguration.minCapitalAmount = 0; this.metaConfiguration.maxCapitalAmount = 10000000; },
            19: () => { this.metaConfiguration.tasaAnual = 0; },
            20: () => { this.metaConfiguration.clavePromocion = []; },
            21: () => { this.metaConfiguration.nuevoCliente = []; this.metaSelectedNuevoCliente = []; },
            22: () => { this.metaAsesorViewCatalog = []; },
        };
        const fn = mapa[campoId];
        if (fn) fn();
    }

    toggleSection(section: string): void {
        this.sectionOpen[section] = !this.sectionOpen[section];
    }

    // ── Cambios en tablas ─────────────────────────────────────────

    changeMetaPaymentTerm(term: any, plazosCatalog: any[]): void {
        this.metaConfiguration.paymentTerms = plazosCatalog
            .filter(p =>
                p.comission !== null &&
                p.comission !== undefined &&
                p.comission !== '' &&
                Number(p.comission) > 0
            );
    }

    changeMetaCategoryAsesor(term: any): void {
        this.metaCategoriesView = this.metaCategoriesView.map(c =>
            c.id === term.id ? { ...c, selected: !c.selected } : c
        );
        this.metaConfiguration.categoryAsesor = this.metaCategoriesView
            .filter(c => c.selected)
            .map(c => ({ id: c.id, name: c.name }));
    }

    removeMetaAsesor(asesor: any): void {
        this.metaAsesorViewCatalog = this.metaAsesorViewCatalog.filter(a => a.id !== asesor.id);
    }

    // ── Dropdowns ─────────────────────────────────────────────────

    onTypeAsesorChange(event: any[]): void { this.metaConfiguration.typeAsesor = event; this.metaSelectedEmployeeJob = event.map(e => e.id); }
    onBusinessLineChange(event: any[]): void { this.metaConfiguration.businessLine = event; this.metaSelectedBusinessProduct = event; }
    onGenderChange(event: any[]): void { this.metaConfiguration.gender = event; this.metaSelectedGender = event.map(e => e.id); }
    onCivilStatusChange(event: any[]): void { this.metaConfiguration.civilStatus = event; this.metaSelectedCivilStatus = event; }
    onTypeEmployeeChange(event: any[]): void { this.metaConfiguration.typeEmployee = event; this.metaSelectedTypeEmployee = event; }
    onTypeSaleChange(event: any[]): void { this.metaConfiguration.typeSale = event; this.metaSelectedTypeSale = event.map(e => e.id); }
    onNuevoClienteChange(event: any[]): void { this.metaConfiguration.nuevoCliente = event; this.metaSelectedNuevoCliente = event.map(e => e.id); }

    // ── Guardar / Cancelar ────────────────────────────────────────

    onGuardar(): void {
        let valido = true;

        // ── Validar que el nombre de la promoción esté capturado ──────
        // El nombre vive en la promoción padre, no en el form de la meta.
        // Se recibe como @Input desde el componente contenedor.
        console.log("Validando nombre de promoción:", this.promotionName);
        this.checkErrorNombrePromocion =
            !this.promotionName || !this.promotionName.trim();
        if (this.checkErrorNombrePromocion) {
            valido = false;
        }

        if (!this.metaSchema || !this.metaSchema.campos || !this.metaSchema.campos.length) {
            this.checkErrorMetaSchema = true;
            valido = false;
        } else {
            this.checkErrorMetaSchema = false;
        }

        if (!this.metaSchema || !this.metaSchema.campos || !this.metaSchema.campos.length) {
            this.checkErrorMetaSchema = true;
            valido = false;
        } else {
            this.checkErrorMetaSchema = false;
        }

        this.checkErrorObjetivo = this.metaForm.objetivo == null || this.metaForm.objetivo <= 0;
        if (this.checkErrorObjetivo) valido = false;

        this.checkErrorFechaInicio = !this.metaForm.fechaInicio;
        this.checkErrorFechaFin = !this.metaForm.fechaFin;
        this.checkErrorFechaCorte = !this.metaForm.fechaCorte;

        if (this.checkErrorFechaInicio || this.checkErrorFechaFin || this.checkErrorFechaCorte) valido = false;

        if (!this.promoShowConfig.fieldPaymentTerm) {
            this.checkErrorComisionMeta = this.metaForm.comisionMeta == null || this.metaForm.comisionMeta <= 0;
            if (this.checkErrorComisionMeta) valido = false;
        } else {
            this.checkErrorComisionMeta = false;
        }

        // ── Validar selección en tablas ───────────────────────────────

        // Tabla: Solo Plazos (Comisiones por Meta de la promoción)
        if (this.promoShowConfig.fieldPaymentTerm && !this.promoShowConfig.fieldCategoryAsesor) {
            const algunoSeleccionado = this.metaComisionesView.some((row: any) => row.comision > 0);
            if (!algunoSeleccionado) {
                this.checkErrorTablaPlazos = true;
                valido = false;
            } else {
                this.checkErrorTablaPlazos = false;
            }
        } else {
            this.checkErrorTablaPlazos = false;
        }

        // Tabla: Solo Categorías (Comisiones por Meta de la promoción)
        if (!this.promoShowConfig.fieldPaymentTerm && this.promoShowConfig.fieldCategoryAsesor) {
            const algunoSeleccionado = this.metaComisionesView.some((row: any) => row.selected);
            if (!algunoSeleccionado) {
                this.checkErrorTablaCategorias = true;
                valido = false;
            } else {
                this.checkErrorTablaCategorias = false;
            }
        } else {
            this.checkErrorTablaCategorias = false;
        }

        // Tabla: Plazos sin categorías (Asesores y Plazos por Meta)
        if (this.metaShowConfig.fieldPaymentTerm && !this.metaShowConfig.fieldCategoryAsesor) {
            const algunoConComision = this.metaPlazosCatalogView.some((p: any) => p.comission > 0);
            if (!algunoConComision) {
                this.checkErrorTablaMetaPlazos = true;
                valido = false;
            } else {
                this.checkErrorTablaMetaPlazos = false;
            }
        } else {
            this.checkErrorTablaMetaPlazos = false;
        }

        // Tabla: Plazos x Categorías (Asesores y Plazos por Meta)
        if (this.metaShowConfig.fieldPaymentTerm && this.metaShowConfig.fieldCategoryAsesor) {
            const algunoSeleccionado = this.metaPaymentCategoryCatalog.some(
                (row: any) => row.paymentCat.some((cell: any) => cell.comission > 0)
            );
            if (!algunoSeleccionado) {
                this.checkErrorTablaMetaPlazosxCats = true;
                valido = false;
            } else {
                this.checkErrorTablaMetaPlazosxCats = false;
            }
        } else {
            this.checkErrorTablaMetaPlazosxCats = false;
        }

        // Tabla: Categorías sin plazos (Asesores y Plazos por Meta)
        if (!this.metaShowConfig.fieldPaymentTerm && this.metaShowConfig.fieldCategoryAsesor) {
            const algunoSeleccionado = this.metaCategoriesView.length > 0;
            if (!algunoSeleccionado) {
                this.checkErrorTablaMetaCategorias = true;
                valido = false;
            } else {
                this.checkErrorTablaMetaCategorias = false;
            }
        } else {
            this.checkErrorTablaMetaCategorias = false;
        }

        // ── Validar campos de geografía y productos ───────────────────

        if (this.metaShowConfig.fieldRegion) {
            this.checkErrorRegion = !this.metaConfiguration.region || !this.metaConfiguration.region.length;
            if (this.checkErrorRegion) valido = false;
        } else { this.checkErrorRegion = false; }

        if (this.metaShowConfig.fieldState) {
            this.checkErrorEstado = !this.metaConfiguration.estado || !this.metaConfiguration.estado.length;
            if (this.checkErrorEstado) valido = false;
        } else { this.checkErrorEstado = false; }

        if (this.metaShowConfig.fieldSucursal) {
            this.checkErrorSucursal = !this.metaConfiguration.sucursal || !this.metaConfiguration.sucursal.length;
            if (this.checkErrorSucursal) valido = false;
        } else { this.checkErrorSucursal = false; }

        if (this.metaShowConfig.fieldProduct) {
            this.checkErrorProducto = !this.metaConfiguration.producto || !this.metaConfiguration.producto.length;
            if (this.checkErrorProducto) valido = false;
        } else { this.checkErrorProducto = false; }

        if (this.metaShowConfig.fieldDependency) {
            this.checkErrorDependencia = !this.metaConfiguration.dependencia || !this.metaConfiguration.dependencia.length;
            if (this.checkErrorDependencia) valido = false;
        } else { this.checkErrorDependencia = false; }

        if (!valido) {
            const camposConError: string[] = [];

            // ← Primero el nombre de la promoción
            if (this.checkErrorNombrePromocion) {
                camposConError.push('Nombre de la promoción (captúralo antes de crear una meta)');
            }
            if (this.checkErrorMetaSchema) camposConError.push('Campos de configuración de la meta');
            if (this.checkErrorObjetivo) camposConError.push('Objetivo');
            if (this.checkErrorMetaSchema) camposConError.push('Campos de configuración de la meta');
            if (this.checkErrorObjetivo) camposConError.push('Objetivo');
            if (this.checkErrorFechaInicio) camposConError.push('Fecha Inicio');
            if (this.checkErrorFechaFin) camposConError.push('Fecha Fin');
            if (this.checkErrorFechaCorte) camposConError.push('Fecha Corte');
            if (this.checkErrorComisionMeta) camposConError.push('Comisión');
            if (this.checkErrorTablaPlazos) camposConError.push('Comisiones por Meta — selecciona al menos un plazo');
            if (this.checkErrorTablaCategorias) camposConError.push('Comisiones por Meta — selecciona al menos una categoría');
            if (this.checkErrorTablaMetaPlazos) camposConError.push('Asesores y Plazos por Meta — selecciona al menos un plazo');
            if (this.checkErrorTablaMetaPlazosxCats) camposConError.push('Asesores y Plazos por Meta — selecciona al menos una celda');
            if (this.checkErrorTablaMetaCategorias) camposConError.push('Asesores y Plazos por Meta — selecciona al menos una categoría');
            if (this.checkErrorRegion) camposConError.push('Regiones');
            if (this.checkErrorEstado) camposConError.push('Estados');
            if (this.checkErrorSucursal) camposConError.push('Sucursales');
            if (this.checkErrorProducto) camposConError.push('Productos');
            if (this.checkErrorDependencia) camposConError.push('Dependencias');

            Swal.fire({
                icon: 'warning',
                title: 'Campos requeridos',
                html: `<p style="margin-bottom:8px;">Por favor completa los siguientes campos:</p>
                <ul style="text-align:left; padding-left:20px;">
                    ${camposConError.map(c => `<li>${c}</li>`).join('')}
                </ul>`,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#2e7d5e',
            });
            return;
        }

        // paymentTerms
        if (this.metaShowConfig.fieldPaymentTerm && this.metaShowConfig.fieldCategoryAsesor) {
            // Extraer plazos únicos con comisión > 0 de metaPaymentCategoryCatalog
            const plazos = new Map();
            this.metaPaymentCategoryCatalog.forEach((row: any) => {
                if (row.paymentCat.some((cell: any) => (cell.comission || 0) > 0)) {
                    plazos.set(row.plazoId, { id: row.plazoId, name: row.plazoName });
                }
            });
            this.metaConfiguration.paymentTerms = Array.from(plazos.values());
        } else if (this.metaShowConfig.fieldPaymentTerm) {
            this.metaConfiguration.paymentTerms = this.metaPlazosCatalogView
                .filter(p => Number(p.comission) > 0);
        }

        // categoryAsesor
        if (this.metaShowConfig.fieldCategoryAsesor && this.metaShowConfig.fieldPaymentTerm) {
            const cats = new Map();
            this.metaPaymentCategoryCatalog.forEach((row: any) => {
                row.paymentCat
                    .filter((cell: any) => cell.selected)
                    .forEach((cell: any) => {
                        if (!cats.has(cell.categoryId)) {
                            cats.set(cell.categoryId, { id: cell.categoryId, name: cell.categoryName });
                        }
                    });
            });
            this.metaConfiguration.categoryAsesor = Array.from(cats.values());
        } else if (this.metaShowConfig.fieldCategoryAsesor) {
            this.metaConfiguration.categoryAsesor = this.metaCategoriesView
                .filter(c => c.selected)
                .map(c => ({ id: c.id, name: c.name }));
        }

        console.log('Guardando meta con configuración:', this.metaConfiguration);

        this.guardar.emit({
            metaForm: { ...this.metaForm },
            metaSchema: this.metaSchema,
            metaConfiguration: { ...this.metaConfiguration },
            metaComisiones: this.buildMetaComisionesPayload(),
            metaPlazosCatalog: this.metaPlazosCatalogView,
            metaPaymentCategoryCatalog: this.metaPaymentCategoryCatalog,
            metaAsesorViewCatalog: this.metaAsesorViewCatalog,
            metaShowConfig: { ...this.metaShowConfig },
            metaCategoriesView: this.metaCategoriesView,
        });
    }

    onCancelar(): void {
        this.cancelar.emit();
    }

    // ── Build vistas y payloads ───────────────────────────────────

    buildMetaComisionesView(): void {
        // ← Preservar valores actuales antes de reconstruir
        const v = (val: any) => (val !== null && val !== undefined) ? val : 'null';
        const valoresActuales = new Map<string, any>();
        (this.metaComisionesView || []).forEach((row: any) => {
            if (row.paymentCat) {
                row.paymentCat.forEach((cell: any) => {
                    valoresActuales.set(`${v(cell.plazoValor)}-${v(cell.categoriaAsesorId)}`, cell);
                });
            } else {
                const key = `${v(row.plazoValor)}-${v(row.categoriaAsesorId)}-${v(row.empleado)}`;
                valoresActuales.set(key, row);
            }
        });

        this.metaComisionesView = [];
        const tienePlazos = this.promoShowConfig.fieldPaymentTerm;
        const tieneCategorias = this.promoShowConfig.fieldCategoryAsesor;
        const tieneAsesores = this.promoShowConfig.fieldAsesor;
        console.log('tienePlazos:', tienePlazos, 'tieneCategorias:', tieneCategorias, 'tieneAsesores:', tieneAsesores);

        if (tienePlazos && tieneCategorias) {
            this.metaComisionesView = this.promoPlazosCatalog.map((plazo: any) => ({
                plazoId: plazo.id,
                plazoName: plazo.name,
                paymentCat: this.promoCategoriesView.map((cat: any) => {
                    const key = `${parseInt(plazo.name, 10)}-${cat.id}`;
                    const actual = valoresActuales.get(key);
                    const existente = actual || (this.metaComisionesExistentes || []).find(
                        (c: any) => c.plazoValor === parseInt(plazo.name, 10) && c.categoriaAsesorId === cat.id
                    );
                    return {
                        plazoId: plazo.id,
                        plazoValor: parseInt(plazo.name, 10),
                        categoriaAsesorId: cat.id,
                        categoryName: cat.name,
                        empleado: null,
                        comision: existente ? existente.comision : 0,
                    };
                })
            }));
        } else if (tienePlazos && !tieneCategorias) {
            this.metaComisionesView = this.promoPlazosCatalog.map((plazo: any) => {
                const key = `${parseInt(plazo.name, 10)}-null-null`;
                const actual = valoresActuales.get(key);
                const existente = actual || (this.metaComisionesExistentes || []).find(
                    (c: any) => c.plazoValor === parseInt(plazo.name, 10)
                );
                return {
                    plazoId: plazo.id,
                    plazoValor: parseInt(plazo.name, 10),
                    plazoName: plazo.name,
                    categoriaAsesorId: null,
                    empleado: null,
                    comision: existente ? existente.comision : 0,
                    selected: existente ? (existente.selected !== undefined ? existente.selected : !!existente) : false,
                };
            });
        } else if (!tienePlazos && tieneCategorias) {
            this.metaComisionesView = this.promoCategoriesView.map(cat => {
                const key = `null-${cat.id}-null`;
                const actual = valoresActuales.get(key);
                const existente = actual || (this.metaComisionesExistentes || []).find(
                    (c: any) => c.categoriaAsesorId === cat.id && c.plazoValor === null
                );
                return {
                    plazoValor: null,
                    categoriaAsesorId: cat.id,
                    categoryName: cat.name,
                    empleado: null,
                    comision: existente ? existente.comision : 0,
                    selected: existente ? (existente.selected !== undefined ? existente.selected : !!existente) : false,
                };
            });
        } else if (tieneAsesores && !tienePlazos) {
            this.metaComisionesView = this.promoAsesorView.map(asesor => {
                const key = `null-null-${asesor.number}`;
                const actual = valoresActuales.get(key);
                return {
                    plazoValor: null,
                    categoriaAsesorId: null,
                    empleado: asesor.number,
                    asesorName: asesor.name,
                    comision: actual ? actual.comision : 0,
                };
            });
        } else if (tieneAsesores && tienePlazos) {
            this.metaComisionesView = this.promoAsesorView.map(asesor => ({
                empleado: asesor.number,
                asesorName: asesor.name,
                plazos: this.promoPlazosCatalog.map(plazo => {
                    const key = `${parseInt(plazo.name, 10)}-null-${asesor.number}`;
                    const actual = valoresActuales.get(key);
                    return {
                        plazoId: plazo.id,
                        plazoValor: parseInt(plazo.name, 10),
                        plazoName: plazo.name,
                        categoriaAsesorId: null,
                        empleado: asesor.number,
                        comision: actual ? actual.comision : 0,
                    };
                })
            }));
        }
    }

    buildMetaComisionesPayload(): MetaComision[] {
        const result: MetaComision[] = [];
        const tienePlazos = this.promoShowConfig.fieldPaymentTerm;
        const tieneCategorias = this.promoShowConfig.fieldCategoryAsesor;
        const tieneAsesores = this.promoShowConfig.fieldAsesor;
        const tieneMetaPlazos = this.metaShowConfig.fieldPaymentTerm;
        const tieneMetaCats = this.metaShowConfig.fieldCategoryAsesor;

        if (tienePlazos && tieneCategorias) {
            this.metaComisionesView.forEach((row: any) => {
                row.paymentCat
                    .filter((cell: any) => cell.comision > 0)
                    .forEach((cell: any) => result.push({
                        plazoValor: cell.plazoValor,
                        categoriaAsesorId: cell.categoriaAsesorId,
                        empleado: null,
                        comision: cell.comision,
                    }));
            });
        } else if (tienePlazos && !tieneCategorias) {
            this.metaComisionesView
                .filter((row: any) => row.comision > 0)
                .forEach((row: any) => result.push({
                    plazoValor: row.plazoValor,
                    categoriaAsesorId: null,
                    empleado: null,
                    comision: row.comision,
                }));
        } else if (!tienePlazos && tieneCategorias) {
            // ← comisionMeta aplica a cada categoría seleccionada
            this.metaComisionesView
                .filter((row: any) => row.selected === true)
                .forEach((row: any) => result.push({
                    plazoValor: null,
                    categoriaAsesorId: row.categoriaAsesorId,
                    empleado: null,
                    comision: this.metaForm.comisionMeta || 0,
                }));
        } else if (tieneAsesores && !tienePlazos) {
            this.metaComisionesView
                .filter((row: any) => row.comision > 0)
                .forEach((row: any) => result.push({
                    plazoValor: null,
                    categoriaAsesorId: null,
                    empleado: row.empleado,
                    comision: row.comision,
                }));
        } else if (tieneAsesores && tienePlazos) {
            this.metaComisionesView.forEach((asesor: any) => {
                asesor.plazos
                    .filter((p: any) => p.comision > 0)
                    .forEach((p: any) => result.push({
                        plazoValor: p.plazoValor,
                        categoriaAsesorId: null,
                        empleado: p.empleado,
                        comision: p.comision,
                    }));
            });
        }

        // ← Sin plazos, sin categorías, sin asesores: registro único con comisionMeta
        if (!tienePlazos && !tieneCategorias && !tieneAsesores) {
            result.push({
                plazoValor: null,
                categoriaAsesorId: null,
                empleado: null,
                comision: this.metaForm.comisionMeta || 0,
            });
        }

        if (tieneMetaPlazos && tieneMetaCats) {
            this.metaPaymentCategoryCatalog.forEach((row: any) => {
                row.paymentCat
                    .filter((cell: any) => cell.comision > 0)
                    .forEach((cell: any) => result.push({
                        plazoValor: parseInt(row.plazoName, 10),
                        categoriaAsesorId: cell.categoryId,
                        empleado: null,
                        comision: cell.comision || 0,
                    }));
            });
        }

        return result;
    }

    // ── Pre-carga filtro existente ────────────────────────────────

    private preCargarFiltroExistente(filtro: any): void {

        if (!filtro) return;
        if (filtro.estructura && filtro.estructura.campos) {
            this.metaSchema = {
                promotionSchemaId: filtro.estructura.estructuraId,
                promotionSchemaName: filtro.estructura.nombreEstructura,
                campos: filtro.estructura.campos || [],
                fields: filtro.estructura.campos || [],
            };
            this.metaSelectedFieldIds = filtro.estructura.campos
                .filter((c: any) => c.activoId == 1)
                .map((c: any) => c.campoId);

            this.metaShowConfig = {
                fieldAsesorType: false, fieldBusinessLine: false, fieldTasaAnual: false,
                fieldGender: false, fieldAge: false, fieldCivilStatus: false,
                fieldEmployeeType: false, fieldSaleType: false, fieldNuevoCliente: false,
                fieldCapitalAmount: false, fieldRegion: false, fieldState: false,
                fieldSucursal: false, fieldProduct: false, fieldDependency: false,
                fieldClavePromocion: false, fieldPaymentTerm: false,
                fieldCategoryAsesor: false, fieldAsesor: false,
            };
            this.metaSelectedFieldIds.forEach(id => this.activarCampoMeta(id));
        }

        if (filtro.listTipoAsesor && filtro.listTipoAsesor.length) {
            this.metaConfiguration.typeAsesor = filtro.listTipoAsesor
                .filter((e: any) => e.tipoAsesorId != null)
                .map((e: any) => this.employeeJobCatalog.find(j => j.id === e.tipoAsesorId)
                    || { id: e.tipoAsesorId, description: e.tipoAsesorValor || '' });
            this.metaSelectedEmployeeJob = this.metaConfiguration.typeAsesor.map((e: any) => e.id);
        }

        if (filtro.listLineaNegocio && filtro.listLineaNegocio.length) {
            this.metaConfiguration.businessLine = filtro.listLineaNegocio
                .filter((e: any) => e.lineaNegocioId != null)
                .map((e: any) => this.businessProductCatalog.find(b => b.id === e.lineaNegocioId && b.core === e.core)
                    || { id: e.lineaNegocioId, description: e.lineaNegocioValor || '', core: e.core });
            this.metaSelectedBusinessProduct = this.metaConfiguration.businessLine;
        }

        if (filtro.listGenero && filtro.listGenero.length) {
            this.metaConfiguration.gender = filtro.listGenero
                .filter((e: any) => e.generoId != null)
                .map((e: any) => this.genderCatalog.find(g => g.id === e.generoId)
                    || { id: e.generoId, description: e.generoValor || '' });
            this.metaSelectedGender = this.metaConfiguration.gender.map((e: any) => e.id);
        }

        if (filtro.listEdad && filtro.listEdad.length) {
            this.metaConfiguration.minAge = filtro.listEdad[0].edadMinima || 0;
            this.metaConfiguration.maxAge = filtro.listEdad[0].edadMaxima || 100;
        }

        if (filtro.listEstadoCivil && filtro.listEstadoCivil.length) {
            this.metaConfiguration.civilStatus = filtro.listEstadoCivil
                .filter((e: any) => e.estadoCivilId != null)
                .map((e: any) => this.civilStatusCatalog.find(c => c.id === e.estadoCivilId && c.core === e.core)
                    || { id: e.estadoCivilId, description: e.estadoCivilValor || '', core: e.core });
            this.metaSelectedCivilStatus = this.metaConfiguration.civilStatus;
        }

        if (filtro.listTipoEmpleado && filtro.listTipoEmpleado.length) {
            this.metaConfiguration.typeEmployee = filtro.listTipoEmpleado
                .filter((e: any) => e.tipoEmpleadoId != null)
                .map((e: any) => this.typeEmployeeCatalog.find(t => t.id === e.tipoEmpleadoId && t.core === e.core)
                    || { id: e.tipoEmpleadoId, description: e.tipoEmpleadoValor || '', core: e.core });
            this.metaSelectedTypeEmployee = this.metaConfiguration.typeEmployee;
        }

        if (filtro.listTipoVenta && filtro.listTipoVenta.length) {
            this.metaConfiguration.typeSale = filtro.listTipoVenta
                .filter((e: any) => e.tipoVentaId != null)
                .map((e: any) => this.typeSaleCatalog.find(s => s.id === e.tipoVentaId)
                    || { id: e.tipoVentaId, description: e.tipoVentaValor || '' });
            this.metaSelectedTypeSale = this.metaConfiguration.typeSale.map((e: any) => e.id);
        }

        if (filtro.listNuevoCliente && filtro.listNuevoCliente.length) {
            this.metaConfiguration.nuevoCliente = filtro.listNuevoCliente
                .filter((e: any) => e.nuevoClienteId != null)
                .map((e: any) => this.nuevoClienteCatalog.find(n => n.id === e.nuevoClienteId)
                    || { id: e.nuevoClienteId, description: e.nuevoClienteValor || '' });
            this.metaSelectedNuevoCliente = this.metaConfiguration.nuevoCliente.map((e: any) => e.id);
        }

        if (filtro.listMontoCapital && filtro.listMontoCapital.length) {
            this.metaConfiguration.minCapitalAmount = filtro.listMontoCapital[0].montoCapitalMinimo || 0;
            this.metaConfiguration.maxCapitalAmount = filtro.listMontoCapital[0].montoCapitalMaximo || 10000000;
        }

        if (filtro.listTasaAnual && filtro.listTasaAnual.length) {
            this.metaConfiguration.tasaAnual = filtro.listTasaAnual[0].tasaAnual || 0;
        }

        if (filtro.listRegion && filtro.listRegion.length) {
            this.metaConfiguration.region = filtro.listRegion
                .filter((e: any) => e.regionId != null)
                .map((e: any) => this.regionCatalog.find(r => r._id === e.regionId)
                    || { _id: e.regionId, _name: e.regionValor || '' });
        }

        if (filtro.listEstado && filtro.listEstado.length) {
            this.metaConfiguration.estado = filtro.listEstado
                .filter((e: any) => e.estadoId != null)
                .map((e: any) => this.stateViewCatalog.find(s => s._id === e.estadoId)
                    || { _id: e.estadoId, _name: e.estadoValor || '' });
        }

        if (filtro.listSucursal && filtro.listSucursal.length) {
            this.metaConfiguration.sucursal = filtro.listSucursal
                .filter((e: any) => e.sucursalId != null)
                .map((e: any) => this.sucursalViewCatalog.find(s => s._id === e.sucursalId)
                    || { _id: e.sucursalId, _name: e.sucursalValor || '' });
        }

        if (filtro.listDependencia && filtro.listDependencia.length) {
            this.metaConfiguration.dependencia = filtro.listDependencia
                .filter((e: any) => e.dependenciaId != null)
                .map((e: any) => this.dependenciesViewCatalog.find(d => d._id_int === e.dependenciaId && d.core === e.core)
                    || { _id_int: e.dependenciaId, _name: e.dependenciaValor || '', core: e.core });
        }

        if (filtro.listProducto && filtro.listProducto.length) {
            this.metaConfiguration.producto = filtro.listProducto
                .filter((e: any) => e.productoId != null)
                .map((e: any) => this.productViewCatalog.find(p => p._id_int === e.productoId && p.core === e.core)
                    || { _id_int: e.productoId, _name: e.productoValor || '', core: e.core });
        }

        if (filtro.listClavePromocion && filtro.listClavePromocion.length) {
            this.metaConfiguration.clavePromocion = filtro.listClavePromocion
                .filter((e: any) => e.clavePromocionId != null)
                .map((e: any) => this.clavePromocionCatalog.find(c => c._id_int === e.clavePromocionId)
                    || { _id_int: e.clavePromocionId, _name: e.clavePromocionValor || '' });
        }

        // ── Categorías sin plazos ─────────────────────────────────
        if (filtro.listCategoriaAsesor && filtro.listCategoriaAsesor.length &&
            this.metaShowConfig.fieldCategoryAsesor && !this.metaShowConfig.fieldPaymentTerm) {
            const idsSeleccionados = new Set(
                filtro.listCategoriaAsesor.map((c: any) => c.categoriaAsesorId)
            );

            const fuenteCats = this.metaShowConfig.fieldAsesorType && this.metaConfiguration.typeAsesor.length
                ? this.categoriesViewCatalog.filter(c =>
                    this.metaConfiguration.typeAsesor.some((t: any) => t.id === c.fatherId))
                : this.categoriesViewCatalog;

            this.metaCategoriesView = this.getCategoriasSinDuplicados(fuenteCats).map(cat => ({
                ...cat,
                selected: idsSeleccionados.has(cat.id),
            }));
        }

        if (this.metaShowConfig.fieldPaymentTerm && !this.metaShowConfig.fieldCategoryAsesor) {
            const base = this.promoPlazosCatalog.length
                ? this.promoPlazosCatalog
                : this.plazosCatalog;

            const mapaComisiones = new Map<number, number>(
                (filtro.listPlazo || []).map((p: any) => [p.plazoId, p.comision || 0])
            );

            this.metaPlazosCatalogView = base.map(plazo => ({
                ...plazo,
                selected: true,
                comission: mapaComisiones.get(plazo.id) || 0,
            }));
        }

        // ── Plazos x Categorías ───────────────────────────────────
        if (filtro.listPlazo && filtro.listPlazo.length &&
            this.metaShowConfig.fieldPaymentTerm && this.metaShowConfig.fieldCategoryAsesor) {
            const fuentePlazoCats = this.metaShowConfig.fieldAsesorType && this.metaConfiguration.typeAsesor.length
                ? this.categoriesViewCatalog.filter(c =>
                    this.metaConfiguration.typeAsesor.some((t: any) => t.id === c.fatherId))
                : this.categoriesViewCatalog;

            this.metaPaymentCategoryCatalog = this.metaPlazosCatalog.map((plazo: any) => ({
                plazoId: plazo.id,
                plazoName: plazo.name,
                paymentCat: this.getCategoriasSinDuplicados(fuentePlazoCats).map((cat: any) => {
                    const existente = filtro.listPlazo.find(
                        (p: any) => (p.plazoId === plazo.id || String(p.plazoValor) === String(plazo.name))
                            && p.categoriaId === cat.id
                    );
                    return {
                        plazoId: plazo.id,
                        plazoName: plazo.name,
                        categoryId: cat.id,
                        categoryName: cat.name,
                        comission: existente ? (existente.comision || 0) : 0,
                        selected: !!existente,
                    };
                })
            }));
        }
        // Geografía
        if (this.metaShowConfig.fieldRegion && this.metaConfiguration.region.length) {
            this.onMetaRegionChange();
        } else {
            // ← Sin región activa o sin selección: catálogo completo
            this.metaStateViewCatalog = [...this.stateViewCatalog];
            this.metaSucursalViewCatalog = [...this.sucursalViewCatalog];
        }

        if (this.metaShowConfig.fieldState && this.metaConfiguration.estado.length
            && !this.metaShowConfig.fieldRegion) {
            this.onMetaEstadoChange();
        }

        // Productos
        if (this.metaShowConfig.fieldBusinessLine && this.metaConfiguration.businessLine.length) {
            this.onMetaBusinessLineChange(this.metaConfiguration.businessLine);
        } else {
            // ← Sin línea activa o sin selección: catálogo completo
            this.metaProductViewCatalog = [...this.productViewCatalog];
            this.metaDependenciesViewCatalog = [...this.dependenciesViewCatalog];
        }

        if (this.metaShowConfig.fieldProduct && this.metaConfiguration.producto.length
            && !this.metaShowConfig.fieldBusinessLine) {
            this.onMetaProductChange();
        }
    }

    public plazoTableKey = 0;

    // ── Reconstruir tabla Plazos x Categorías ─────────────────────

    private reconstruirMetaPaymentCategory(): void {
        const catalogActual = this.metaPaymentCategoryCatalog;
        this.metaPaymentCategoryCatalog = this.metaPlazosCatalog.map(plazo => ({
            plazoId: plazo.id,
            plazoName: plazo.name,
            paymentCat: this.metaCategoriesView.map(cat => {
                const filaExistente = catalogActual.find(p => p.plazoName === plazo.name);
                const existente = filaExistente
                    ? filaExistente.paymentCat.find((c: any) => c.categoryId === cat.id)
                    : null;
                return {
                    plazoId: plazo.id,
                    plazoName: plazo.name,
                    categoryId: cat.id,
                    categoryName: cat.name,
                    comission: existente ? existente.comission : 0,
                    selected: existente ? existente.comission > 0 : false,
                };
            })
        }));
    }

    // ── Cascada Geografía Meta ────────────────────────────────────

    onMetaRegionChange(): void {
        if (!this.metaConfiguration.region || !this.metaConfiguration.region.length) {
            this.metaStateViewCatalog = [];
            this.metaConfiguration.estado = [];
            this.metaSucursalViewCatalog = [];
            this.metaConfiguration.sucursal = [];
            return;
        }
        const estados = [];
        this.metaConfiguration.region.forEach((region: any) => {
            estados.push(...this.stateViewCatalog.filter(s => s._regionId === region._id));
        });
        this.metaStateViewCatalog = estados;

        if (this.metaShowConfig.fieldState) {
            this.metaConfiguration.estado = this.metaConfiguration.estado
                .filter((e: any) => this.metaStateViewCatalog.some(s => s._id === e._id));
        } else {
            this.metaConfiguration.estado = [...this.metaStateViewCatalog];
        }
        this.onMetaEstadoChange();
    }

    onMetaEstadoChange(): void {
        if (!this.metaConfiguration.estado || !this.metaConfiguration.estado.length) {
            if (this.metaShowConfig.fieldSucursal) {
                this.metaSucursalViewCatalog = [];
                this.metaConfiguration.sucursal = [];
            } else {
                this.metaSucursalViewCatalog = [...this.sucursalViewCatalog];
                this.metaConfiguration.sucursal = [...this.sucursalViewCatalog];
            }
            return;
        }
        const sucursales = [];
        this.metaConfiguration.estado.forEach((estado: any) => {
            sucursales.push(...this.sucursalViewCatalog.filter(s => s._estadoId === estado._id));
        });
        this.metaSucursalViewCatalog = sucursales;
        this.metaConfiguration.sucursal = this.metaConfiguration.sucursal
            .filter((s: any) => this.metaSucursalViewCatalog.some(sv => sv._id === s._id));

        if (!this.metaShowConfig.fieldSucursal) {
            this.metaConfiguration.sucursal = [...this.metaSucursalViewCatalog];
        }
    }

    onMetaBusinessLineChange(event: any[]): void {
        this.metaConfiguration.businessLine = event;
        this.metaSelectedBusinessProduct = event;

        if (!event || !event.length) {
            // ← Sin línea: mostrar todos los productos
            this.metaProductViewCatalog = [...this.productViewCatalog];
            this.metaConfiguration.producto = [];
            this.metaDependenciesViewCatalog = this.getDependenciasSinDuplicados(this.dependenciesViewCatalog);
            this.metaConfiguration.dependencia = [];
            return;
        }

        const products = [];
        event.forEach((line: any) => {
            products.push(...this.productViewCatalog.filter(
                p => p._bussinesLineId === line.id && p.core === line.core
            ));
        });
        const ids = products.map(p => p._id_int).filter((v, i, a) => a.indexOf(v) === i);

        this.metaProductViewCatalog = ids.map(id => products.find(p => p._id_int === id));

        if (this.metaShowConfig.fieldProduct) {
            this.metaConfiguration.producto = this.metaConfiguration.producto
                .filter((p: any) => this.metaProductViewCatalog.some(
                    pv => pv._id_int === p._id_int && pv.core === p.core
                ));
        } else {
            this.metaConfiguration.producto = [...this.metaProductViewCatalog];
        }

        this.onMetaProductChange();
    }

    onMetaProductChange(): void {
        if (!this.metaConfiguration.producto || !this.metaConfiguration.producto.length) {
            if (this.metaShowConfig.fieldDependency) {
                this.metaDependenciesViewCatalog = [];
                this.metaConfiguration.dependencia = [];
            } else {
                this.metaDependenciesViewCatalog = this.getDependenciasSinDuplicados(this.dependenciesViewCatalog);
                this.metaConfiguration.dependencia = [...this.metaDependenciesViewCatalog];
            }
            return;
        }

        const dependencies = [];
        this.metaConfiguration.producto.forEach((product: any) => {
            dependencies.push(...this.dependenciesViewCatalog.filter(
                d => d._productId === product._id_int && d.core === product.core
            ));
        });
        this.metaDependenciesViewCatalog = this.getDependenciasSinDuplicados(dependencies);
        this.metaConfiguration.dependencia = this.metaConfiguration.dependencia
            .filter((d: any) => this.metaDependenciesViewCatalog.some(
                dv => dv._id_int === d._id_int && dv.core === d.core
            ));

        if (!this.metaShowConfig.fieldDependency) {
            this.metaConfiguration.dependencia = [...this.metaDependenciesViewCatalog];
        }
    }

    onMetaTypeAsesorChange(event: any[]): void {
        this.metaConfiguration.typeAsesor = event;
        this.metaSelectedEmployeeJob = event.map((e: any) => e.id);

        if (!event || !event.length) {
            this.metaCategoriesView = [];
            this.metaConfiguration.categoryAsesor = [];
            // Limpiar también la tabla
            if (this.metaShowConfig.fieldPaymentTerm && this.metaShowConfig.fieldCategoryAsesor) {
                this.reconstruirMetaPaymentCategory();
            }
            return;
        }

        const categories: any[] = [];
        event.forEach((type: any) => {
            categories.push(...this.categoriesViewCatalog.filter(c => c.fatherId === type.id));
        });

        // ← Deduplicación correcta por id
        this.metaCategoriesView = this.getCategoriasSinDuplicados(categories)
            .map(c => ({ ...c, selected: false }));

        this.metaConfiguration.categoryAsesor = this.metaCategoriesView.filter(c => c.commision > 0);

        // ← BUG 1 FIX: reconstruir la tabla con las nuevas categorías
        if (this.metaShowConfig.fieldPaymentTerm && this.metaShowConfig.fieldCategoryAsesor) {
            this.reconstruirMetaPaymentCategory();
        }
    }

    private getCategoriasSinDuplicados(fuente: any[]): any[] {
        const seen = new Set<number>();
        return fuente.filter(c => {
            if (seen.has(c.id)) return false;
            seen.add(c.id);
            return true;
        });
    }

    private getDependenciasSinDuplicados(fuente: any[]): any[] {
        const seen = new Set<number>();
        return fuente.filter(d => {
            if (seen.has(d._id_int)) return false;
            seen.add(d._id_int);
            return true;
        });
    }

}